import * as firebase from "firebase";

export const DB_CONFIG = {
    apiKey: "AIzaSyBUxmwWAxr9LzmIWsq6gAg5T3_snf_uYJ0",
    authDomain: "grademaker-a1324.firebaseapp.com",
    databaseURL: "https://grademaker-a1324.firebaseio.com",
    projectId: "grademaker-a1324",
    storageBucket: "grademaker-a1324.appspot.com",
    messagingSenderId: "400507740917"
};

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(DB_CONFIG) : firebase.app();

export default firebaseApp

// Firestore Config & Convenience functions

firebase.firestore().settings({
    timestampsInSnapshots: true
}) // To avoid warning

const BASE_PATH = 'surveys'

const fullPathForSurveyWithUUID = (uuid) => `${BASE_PATH}/${uuid}`

const documentRefForUUID = (uuid) => {
    const firestore = firebase.firestore()
    const path = fullPathForSurveyWithUUID(uuid)
    const docRef = firestore.doc(path);
    return docRef
}


export const loginAnonymously = () => {
    return firebaseApp.auth().signInAnonymously()
}

window.__signout = () => firebase.auth().signOut()

export const setAuthChangeListener = (calbackFn) => {
    firebase.auth().onAuthStateChanged(calbackFn)
}

export const addSurveyToFireStore = (uuid, payload = {}) => {
    /* This is how to use Firestore*/
    const docRef = documentRefForUUID(uuid)
    return docRef.set({
        ...payload,
        registrationDate: new Date(),
        lastSyncedAt: new Date(),
        docPath: docRef.path,
        host: window ? window.location.host : undefined
    }).then(response => {
        console.info(`synced with ${docRef.path} @ ${new Date()}`)
        return response
    })
}

export const getSurveyFromFireStore = (uuid) => {
    let documentRef = documentRefForUUID(uuid)
    return documentRef.get().then(documentSnapshot => {
        if (documentSnapshot.exists) {
            console.log('Document retrieved successfully.');
        }
        return documentSnapshot
    });
}

// Cloud functions

const functions = firebaseApp.functions()

const testCallableCloudFunction = functions.httpsCallable('helloWorldCallable')

window.___testCallableCloudFunction = testCallableCloudFunction


// WEBPACK FOOTER //
// ./src/Config/config.js